module.exports = __webpack_public_path__ + "static/media/barbuda-3.62e9fa65.jpg";